import { render, staticRenderFns } from "./BankAccountSortCode.vue?vue&type=template&id=3cf16902&scoped=true&"
import script from "./BankAccountSortCode.vue?vue&type=script&lang=js&"
export * from "./BankAccountSortCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf16902",
  null
  
)

export default component.exports